import recruiter1 from "../img/recruiters/1.webp";
import recruiter2 from "../img/recruiters/2.webp";
import recruiter3 from "../img/recruiters/3.webp";
import recruiter4 from "../img/recruiters/4.webp";
import recruiter5 from "../img/recruiters/5.webp";
import recruiter6 from "../img/recruiters/6.webp";
import recruiter7 from "../img/recruiters/7.webp";
import recruiter8 from "../img/recruiters/8.webp";
import recruiter9 from "../img/recruiters/9.webp";
import recruiter10 from "../img/recruiters/10.webp";
import recruiter11 from "../img/recruiters/11.webp";
import recruiter12 from "../img/recruiters/12.webp";
import recruiter13 from "../img/recruiters/13.webp";
import recruiter14 from "../img/recruiters/14.webp";
import recruiter15 from "../img/recruiters/15.webp";
import recruiter16 from "../img/recruiters/16.webp";
import recruiter17 from "../img/recruiters/17.webp";
import recruiter18 from "../img/recruiters/18.webp";
import recruiter19 from "../img/recruiters/19.webp";
import recruiter20 from "../img/recruiters/20.webp";
import recruiter21 from "../img/recruiters/21.webp";
import recruiter22 from "../img/recruiters/22.webp";
import recruiter23 from "../img/recruiters/23.webp";
import recruiter24 from "../img/recruiters/24.webp";
import recruiter25 from "../img/recruiters/25.webp";
import recruiter26 from "../img/recruiters/26.webp";
import recruiter27 from "../img/recruiters/27.webp";
import recruiter28 from "../img/recruiters/28.webp";
import recruiter29 from "../img/recruiters/29.webp";
import recruiter30 from "../img/recruiters/30.webp";
import recruiter31 from "../img/recruiters/31.webp";
import recruiter32 from "../img/recruiters/32.webp";
import recruiter33 from "../img/recruiters/33.webp";
import recruiter34 from "../img/recruiters/34.webp";
import recruiter35 from "../img/recruiters/35.webp";
import recruiter36 from "../img/recruiters/36.webp";
import recruiter37 from "../img/recruiters/37.webp";
import recruiter38 from "../img/recruiters/38.webp";
import recruiter39 from "../img/recruiters/39.webp";
import recruiter40 from "../img/recruiters/40.webp";
import recruiter41 from "../img/recruiters/41.webp";
import recruiter42 from "../img/recruiters/42.webp";
import recruiter43 from "../img/recruiters/43.webp";
import recruiter44 from "../img/recruiters/44.webp";
import recruiter45 from "../img/recruiters/45.webp";
import recruiter46 from "../img/recruiters/46.webp";
import recruiter47 from "../img/recruiters/47.webp";
import recruiter48 from "../img/recruiters/48.webp";
import recruiter49 from "../img/recruiters/49.webp";
import recruiter50 from "../img/recruiters/50.webp";

export const recruiters = [
    recruiter1,
    recruiter2,
    recruiter3,
    recruiter4,
    recruiter5,
    recruiter6,
    recruiter7,
    recruiter8,
    recruiter9,
    recruiter10,
    recruiter11,
    recruiter12,
    recruiter13,
    recruiter14,
    recruiter15,
    recruiter16,
    recruiter17,
    recruiter18,
    recruiter19,
    recruiter20,
    recruiter21,
    recruiter22,
    recruiter23,
    recruiter24,
    recruiter25,
    recruiter26,
    recruiter27,
    recruiter28,
    recruiter29,
    recruiter30,
    recruiter31,
    recruiter32,
    recruiter33,
    recruiter34,
    recruiter35,
    recruiter36,
    recruiter37,
    recruiter38,
    recruiter39,
    recruiter40,
    recruiter41,
    recruiter42,
    recruiter43,
    recruiter44,
    recruiter45,
    recruiter46,
    recruiter47,
    recruiter48,
    recruiter49,
    recruiter50,

];